import type {
  UiMessageBubbleCallbacks,
  UiMessageBubbleDataProps,
} from "../UiMessageBubble";
import { MessageOrder } from "@/components/chat/Chatbox/constants";
import {
  type AtomRecord,
  BaseStore,
  createAtomStore,
} from "@deputy-ai/common/jotai";
import { atom } from "jotai";

export interface UiMessageBubbleStoreOptions {
  propsAtoms: AtomRecord<UiMessageBubbleDataProps>;
  callbacks: UiMessageBubbleCallbacks;
}

export class UiMessageBubbleStore extends BaseStore {
  get propsAtoms() {
    return this.options.propsAtoms;
  }

  get callbacks() {
    return this.options.callbacks;
  }

  uiAvatarVisible = atom((get) => {
    const avatarVisible = get(this.propsAtoms.avatarVisible);

    if (avatarVisible === null) {
      return false;
    }

    const order = get(this.propsAtoms.order);

    if (
      !avatarVisible ||
      order === MessageOrder.Middle ||
      order === MessageOrder.Last
    ) {
      return "placeholder";
    }

    return true;
  });

  uiNameVisible = atom((get) => {
    const nameVisible = get(this.propsAtoms.nameVisible);
    const order = get(this.propsAtoms.order);

    if (
      !nameVisible ||
      order === MessageOrder.Middle ||
      order === MessageOrder.Last
    ) {
      return false;
    }

    return true;
  });

  constructor(private readonly options: UiMessageBubbleStoreOptions) {
    super();
  }
}

export const UiMessageBubbleStoreContext =
  createAtomStore(UiMessageBubbleStore);
